import React from "react";
import { Button } from "components/button";
import { PackingMaterialCard } from "components/PackingMaterialCard";
import "./PackingMaterial.scss"
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { isMobile } from "core/utils";
export interface PackingMaterialProps {
    onClick?(): void;
    formControl?: FormControl;
}

export interface PackingMaterialState {

}

class PackingMaterial extends React.Component<PackingMaterialProps, PackingMaterialState> {
    constructor(props: PackingMaterialProps) {
        super(props);
        this.state = {};
    }
    getSignature() {
        //debugger;
        // var isAffirm=(localStorage.getItem("isAffirm") || "0");
        // if(this.props.formControl){
        //     if(isAffirm=="1"){
        //         this.props.formControl.setValue("1")
        //     }else{
        //         this.props.formControl.setValue("0")
        //     }
        // }

        if (this.props.onClick) {
            this.props.onClick()

        }
    }
    saveSignatures(flag: string) {
        var Customer = JSON.parse(localStorage.getItem("customerDetails") || '{}')
        var params = {
            customerID: Customer.customerID,
            moveID: Customer.moveID,
            moveDailySheetID: Customer.moveDailySheetID,
            estimatorID: Customer.estimatorID,
            signature1: localStorage.getItem("estsigns"),
            signature2: ""
        }
        console.log("PARAMS", params)
        this.saveSignaturesAPI(params)
            .then(response => {

            });
        if (this.props.onClick) {
            this.props.onClick()

        }
    }
    async saveSignaturesAPI(params: any) {
        return client.query({
            query: saveSignatures, variables: {
                sigInput: {
                    "customerID": params.customerID,
                    "moveID": params.moveID,
                    "moveDailySheetID": params.moveDailySheetID,
                    "estimatorID": params.estimatorID,
                    "signature1": params.signature1,
                    "signature2": params.signature2
                }
            }
        });
    }
    render() {
        return (
            <div className="todo-container">
                <div className={"paperContainer"} style={{height:window.innerHeight-150}}>
                <div className="gap short" />
                    <div className="paperworkEst-title">
                        {/* {
                        isSuper ? <h1>Your Super deal move Details</h1>
                            : <h1>Your  Move Details</h1>
                    } */}
                        <h1> Packing Material Summary</h1>
                    </div>
                    <PackingMaterialCard />
                </div>

                <Button
                    text={"Continue"}
                    onClick={() => this.saveSignatures("1")}
                />
            </div>
        );
    }
}

export default PackingMaterial;